// extracted by mini-css-extract-plugin
module.exports = {"pane":"ItemsPane-pane-d9fd","content":"ItemsPane-content-d9fd","more":"ItemsPane-more-d9fd"};